/**
 * @file DefaultGov
 * @author zhaomiaoyuan
 */
import React from 'react';
import {useHistory} from 'react-router-dom';
import Button from 'antd/lib/button';
import {recordProxy} from '../../util';
import './index.less';
interface Props {
    name?:string;
    nextClick(o?: any): void;
}

export default function DefaultGov(props: Props) {
    const {
        name,
        nextClick
    } = props;

    const history = useHistory();
    const freeCertification = () => {
        recordProxy('url-free', 'click', '去免费认证');
        history.push('/attest/step/1');
    };
    return (
        <div className="default-gov">
            <p>{`为政府推荐特殊号码认证，认证后号码不会再被${name || '恶意标记'}`}</p>
            <Button
                className="btn-primary"
                type="primary"
                onClick={freeCertification}>去免费认证</Button>
            <Button
                className="btn"
                onClick={nextClick}>{'继续申诉'}</Button>
        </div>
    );
}
